import React, { useEffect, useState } from "react";
import { UiWhiteCard } from "../common/UiWhiteCard";
import { TransferIcon } from "../../../styles/img/svg/TransferIcon";
import { SettleCardIcon } from "../../../styles/img/svg/SettleCardIcon";
import { useDispatch, useSelector } from "react-redux";
import { clearFundTransferForms } from "../../../_redux/_actions/fundTransfer.actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UiPopup } from "../common/UiModal";
import { SomethingWrongModal } from "../Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { SelectPayeeTypesPopup } from "../../pages/Layout/Popups/SelectPayeeTypesPopup";
import { commonConstants } from "../../../_redux/_constants";
import {
  cardSettlementTypesRequest,
  setCreditCardBillPaymentFLow,
} from "../../../_redux/_actions";
import { BillPaymentIcon } from "../../../styles/img/svg/BillPaymentIcon";

export const UiMobileBottomCard = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const goToFundTransfer = () => {
    dispatch(clearFundTransferForms());
    navigate("/app/fund-transfer");
  };

  const goToBillPay = () => {
    navigate("/app/bill-payments");
  };

  const [filterData, setFilterData] = useState(false);
  const [openCardTypeModal, setOpenCardTypeModal] = useState(false);
  const [featureAvailable, setFeatureUnavailable] = useState(false);

  const payeeTypeList = useSelector(
    (state) => state.creditCardPayments?.payeeTypeList,
  );

  const goToDfccCreditCardBillForm = (params) => {
    dispatch(setCreditCardBillPaymentFLow(params));
    navigate("/app/credit-cards-bill-settle");
  };

  const openSelection = (param) => {
    let payload = {
      isCreditCardPayee: true,
    };

    dispatch(cardSettlementTypesRequest(payload));

    setFilterData(param);
  };

  useEffect(() => {
    if (filterData && payeeTypeList.length > 0) {
      let hasCardPaymentTypes = payeeTypeList.find(
        (e) =>
          e.payeeTypeGroup?.name ==
          commonConstants.BILL_PAYMENT_SELECTOR_CREDIT_CARD_TYPE,
      );

      if (!hasCardPaymentTypes) {
        setFeatureUnavailable(true);
      } else {
        setFeatureUnavailable(false);
        setOpenCardTypeModal(true);
      }
    } else {
      setFeatureUnavailable(false);
      setOpenCardTypeModal(false);
    }
  }, [payeeTypeList]);

  return (
    <>
      <div className="df-icon-card-mobile">
        <UiWhiteCard
          onClick={() => goToFundTransfer()}
          className="df-icon-card"
        >
          <TransferIcon />
          <h5>{t("Transfer")}</h5>
        </UiWhiteCard>

        <UiWhiteCard onClick={() => goToBillPay()} className="df-icon-card">
          <BillPaymentIcon />
          <h5>{t("Bill Payment")}</h5>
        </UiWhiteCard>

        {/* <UiWhiteCard
          onClick={() => openSelection(true)}
          className="df-icon-card"
        >
          <SettleCardIcon />
          <h5>{t("Settle a Card")}</h5>
        </UiWhiteCard> */}
      </div>

      <SelectPayeeTypesPopup
        openModal={openCardTypeModal}
        closeModal={() => {
          openSelection(false);
        }}
        payeeTypeList={payeeTypeList}
        goToDfccCreditCardBillForm={goToDfccCreditCardBillForm}
      />

      <UiPopup
        openModal={featureAvailable}
        handleClose={() => {
          setFeatureUnavailable(false);
        }}
      >
        <SomethingWrongModal
          icon={<ConfirmationIcon />}
          message={t("Feature Unavailable")}
          buttonText={t("Ok")}
          buttonOnClick={() => {
            setFeatureUnavailable(false);
          }}
          className="df-confirmation-message-popup df-btn-grpdmodal"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>
            {t(
              "This feature is currently unavailable. Please check back later.",
            )}
          </p>
          <br />
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
